<template>
	<div id="loader" class="d-flex">
		<div class="overlay"></div>
		<div class="ball align-self-center"></div>
	</div>
</template>

<script>
export default {
	name: 'loader'
}
</script>
<style>
#loader{
	position:absolute;
	top:0;
	bottom:0;
	left:0;
	right:0;
	z-index:2000;
}
.overlay{
	position:absolute;
	top:0;
	bottom:0;
	left:0;
	right:0;
	background-color:rgba(255,255,255,0.6);
}
.ball {
    background-color: rgba(0,0,0,0);
    border: 5px solid rgba(0,183,229,0.6);
    opacity: .9;
    border-top: 5px solid rgba(0,0,0,0);
    border-left: 5px solid rgba(0,0,0,0);
    border-radius: 50px;
    width: 50px;
    height: 50px;
    margin: 0 auto;
    -moz-animation: spin .8s infinite linear;
    -webkit-animation: spin .8s infinite linear;
}
@-moz-keyframes spin {
    0% {
        -moz-transform: rotate(0deg);
    }

    100% {
        -moz-transform: rotate(360deg);
    };
}
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    };
}
</style>


// WEBPACK FOOTER //
// src/components/loader.vue